import $ from 'jquery';
import noop from 'lodash/noop';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { NaturalNumbersOnlyInputDirective } from './natural-numbers-only-input.directive';

const SEARCH_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line:no-use-before-declare
  useExisting: forwardRef(() => SearchInputComponent),
  multi: true,
};

@Component({
  selector: 'search-input',
  styleUrls: ['./search-input.component.scss'],
  templateUrl: './search-input.component.html',
  providers: [
    SEARCH_VALUE_ACCESSOR,
    NaturalNumbersOnlyInputDirective,
  ],
})
export class SearchInputComponent implements AfterViewInit {
  @Input() public disabled: boolean = false;
  @Input() public inputType: string = 'text';
  @Input() public useAntInput: boolean = false;
  @Input() public placeholder: string;
  @Input() public isSearching: boolean;
  @Input() public autofocus?;
  @Output() public crossButtonClicked: EventEmitter<void> = new EventEmitter();
  @ViewChild('inputEle', { static: false }) public inputEle: ElementRef;
  public currentValue: string;
  private el: HTMLElement;
  private $el;
  private _onChangeCallback: any;
  private _onTouchedCallback: any;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
    this.$el = $(this.el);

    this._onChangeCallback = noop;
    this._onTouchedCallback = noop;
  }

  public ngAfterViewInit() {
    this.inputEle.nativeElement.setAttribute('type', this.inputType);
    if (this.hasOwnProperty('autofocus')) {
      this.inputEle.nativeElement.focus();
    }
  }

  public updateCurrentValue(value) {
    this.currentValue = value;
    this._onChangeCallback(this.currentValue);
  }

  public removeValue() {
    this.currentValue = '';
    this._onChangeCallback('');
    this.crossButtonClicked.emit();
  }

  public writeValue(value) {
    this.currentValue = value;
  }

  public registerOnChange(fn) {
    this._onChangeCallback = fn;
  }

  public registerOnTouched(fn) {
    this._onTouchedCallback = fn;
  }

}
